import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form } from "reactstrap";
import { get, put, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Loader from "common/loader";
import { SHOW_COUNTRY, UPDATE_COUNTRY, LANGUAGES_SEARCH } from "helpers/api_endpoints";



//meta title
document.title = "Edit Country";

const EditCountry = () => {
    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [id, setid] = useState('');
    const [name, setname] = useState('');
    const [named, setNamed] = useState([]);
    const [countryCode, setCountryCode] = useState('');
    const [symbol, setSymbol] = useState('');
    const [flagUrl, setFlagUrl] = useState('');
    const [phoneRegEx, setPhoneRegEx] = useState('');
    const [status, setStatus] = useState(false);
    const [languages, setLanguages] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                // console.log(languages);
                setLoading(false);
            })
            .catch(error => {
                navigate('/reasons');
            })
    }, []);

    useEffect(() => {
        get(`${SHOW_COUNTRY}/${params.id}`)
            .then(response => {
                const country = response.data;
                setid(params.id);
                setCountryCode(country.countryCode);
                setSymbol(country.symbol);
                setname(country.name);
                setNamed(country.named);
                setFlagUrl(country.flagUrl);
                setStatus(country.status);
                setPhoneRegEx(country.phoneRegEx);
                setLoading(false);
            })
            .catch(error => {
                navigate('/countries');
            })
    }, []);

    const handleSubmit = () => {
        put(UPDATE_COUNTRY, { id, name, symbol, countryCode, status, flagUrl, phoneRegEx })
            .then(response => {
                if (response.code == 200) {
                    navigate('/countries', { state: { successMsg: 'Country Updated SuccessFully' } });
                }
            })
            .catch(error => {
                console.log(error.response);
            })
    }

    const handleName = (languageId,value) => {
        if(!named.title){
            setNamed({"title":[{"1":""}]});
            return;  
        } 
        const ln = named.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            named.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setname(JSON.stringify(named));             
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Countries" breadcrumbItem="Edit Country" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                            {
                                            languages.map((language, index) => (
                                                <div className="form-group col-md-4 mt-2" key={index}>
                                                    <Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
                                                    <Input
                                                        name="username"
                                                        value={named.title?named.title.find(el => {return el[language.id]})?named.title.find(el => {return el[language.id]})[language.id]:'':JSON.stringify(named)}
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        type="text"
                                                        onChange={(e) => handleName(language.id,e.target.value)}
                                                        required={language.id==1||language.id==2?true:false} ></Input>
                                                    <Input type="hidden" name="id"></Input>
                                                </div>
                                                ))
                                            }
                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Symbol</Trans></Label>
                                                    <Input
                                                        name="symbol"
                                                        value={symbol}
                                                        className="form-control"
                                                        placeholder="Enter Symbol"
                                                        type="text"
                                                        onChange={(e) => setSymbol(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Country Code</Trans></Label>
                                                    <Input
                                                        name="countryCode"
                                                        value={countryCode}
                                                        className="form-control"
                                                        placeholder="Enter country Code"
                                                        type="text"
                                                        onChange={(e) => setCountryCode(e.target.value)} required
                                                    ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Flag Url</Trans></Label>
                                                    <Input
                                                        name="flagUrl"
                                                        value={flagUrl}
                                                        className="form-control"
                                                        placeholder="Enter "
                                                        type="text"
                                                        onChange={(e) => setFlagUrl(e.target.value)} 
                                                    ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Phone regex</Trans></Label>
                                                    <Input
                                                        name="flagUrl"
                                                        value={phoneRegEx}
                                                        className="form-control"
                                                        placeholder="Enter "
                                                        type="text"
                                                        onChange={(e) => setPhoneRegEx(e.target.value)} 
                                                    ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Status</Trans></Label>
                                                    <select className="form-control" onChange={(e) => setStatus(e.target.value)}>
                                                        <option value=''></option>
                                                        <option value={1} selected={status == 1}><Trans>Active</Trans></option>
                                                        <option value={0} selected={status != 1}><Trans>Non Active</Trans></option>
                                                    </select>
                                                </div>
                                                <div className="text-center  mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditCountry
